import React from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'packages/ui/FilterSelectMulti'
import TextField from 'components/global/CUK/TextField'

const Status = ({statuses, values, onChange}) => {
  const { t } = useTranslation()
  const choices = [
    {
      label: t('voip.cdr.status_up'),
      value: 'answered',
      count: statuses?.answered || 0,
      id: 1,
    },
    {
      label: t('voip.cdr.status_down'),
      value: 'unanswered',
      count: statuses?.unanswered || 0,
      id: 2,
    }
  ]

  return (
    <Select
      options={choices}
      onChange={onChange}
      values={values}
      placeholder={t('voip.cdr.status')}
    />
  )
}

export const Types = ({types, values, onChange}) => {
  const { t } = useTranslation()
  const choices = [
    {
      label: t('voip.cdr.in'),
      value: 'in',
      count: types?.in || 0,
      id: 1,
    },
    {
      label: t('voip.cdr.out'),
      value: 'out',
      count: types?.out || 0,
      id: 2,
    },
    {
      label: t('voip.cdr.internal'),
      value: 'internal',
      count: types?.internal || 0,
      id: 2,
    },
  ]

  return (
    <Select
      options={choices}
      onChange={onChange}
      values={values}
      placeholder={t('voip.cdr.type')}
    />
  )
}

export const Verbatim = ({value, onChange}) => {
  const {t} = useTranslation()
  return (
    <TextField
      width={'100%'}
      value={value}
      setvalue={newValue => {
        onChange(newValue)
      }}
      type="text"
      input={{
        placeholder: t('voip.cdr.search_placeholder'),
        starticon: <i className={'fa-light fa-search'} />
      }}
    />
  )
}


export default Status
